import React from 'react'
import { Video } from '../Video/Video'
import styles from './User.module.css'

export const User = ({ streamManager, handleFoolScreenVideoStream, openUsersList, toMainStream, toggleSubscribeAudio, display }) => {
  if (streamManager === undefined) return null

  return (
    <Video
      streamManager={streamManager}
      display={display}
      handleFoolScreenVideoStream={handleFoolScreenVideoStream}
      openUsersList={openUsersList}
      toMainStream={toMainStream}
      toggleSubscribeAudio={toggleSubscribeAudio}
    />
  )
}
